import { Injectable } from '@angular/core';
import { OrganizacioniEntitet2, OrganTipResponse } from 'app/api/iop-katalog-institucija-api-reference';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetujOrganIzMaticneEvidencijeService {
  private data = new BehaviorSubject<KreiranjeOrganaModel>(null);
  public currentData = this.data.asObservable();
  constructor() { }

  setujPodatkeZaKreiranjeOrgana(data: KreiranjeOrganaModel) {
    this.data.next(data);
  }
}

export class KreiranjeOrganaModel {
  orgEntitet: OrganizacioniEntitet2;
  preuzetoIzME: boolean;
  podtipoviNadtipa: OrganTipResponse[];
}
